module.exports = __webpack_public_path__ + "static/img/10.e51a8f1e.png";